/**
 * „გასვლა" — the one sign-out rule (1.49).
 *
 * supabase-js `auth.signOut()` defaults to scope 'global': it revokes EVERY
 * session of the login, on every device. A shop runs several tills on one
 * login, so a sign-out on a phone used to end the whole shop's day
 * (10-16: the owner's „გასვლა" ended MINIMAX's tills). 'local' revokes this
 * device's session only — the server forgets it too, the others keep working.
 *
 * The one deliberate exception is the password reset (app/auth/reset),
 * which names 'global' itself. sign-out.test.ts refuses a bare signOut().
 *
 * 1.67: this device's push subscription is forgotten FIRST (its server row needs the session), so a phone handed to
 * the next waiter never rings for the last one.
 */
import { forgetPushOnThisDevice } from './push-client'

export async function signOutThisDevice(supabase: {
  auth: { signOut: (options: { scope: 'local' }) => Promise<{ error: unknown }> }
}) {
  await forgetPushOnThisDevice().catch(() => {})
  return supabase.auth.signOut({ scope: 'local' })
}
